
export interface DeliveryRoute {
    id: number;
    code: string;
    description: string;
    isDeliveryValue: boolean;
    isMarkUpValue: boolean;
}
